export default {
  namespaced: true,
  state: {
    customerNotRead: false,
    specialistNotRead: false,
  },
  getters: {
    customerNotRead: state => state.customerNotRead,
    specialistNotRead: state => state.specialistNotRead,
  },

  mutations: {
    set_customerNotRead(state, value) {
      state.customerNotRead = value
    },
    set_specialistNotRead(state, value) {
      state.specialistNotRead = value
    },
  },

}
